import { render, staticRenderFns } from "./WyfFeatures.vue?vue&type=template&id=6cf0986e"
var script = {}
import style0 from "./WyfFeatures.vue?vue&type=style&index=0&id=6cf0986e&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports